import * as tslib_1 from "tslib";
/* I33 in DS */
// from GDrive
import React from 'react';
import IconWrap from '../IconWrap';
var Trophy = /** @class */ (function (_super) {
    tslib_1.__extends(Trophy, _super);
    function Trophy() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Trophy.prototype.render = function () {
        return (React.createElement(IconWrap, tslib_1.__assign({}, this.props),
            React.createElement("svg", { width: "0", height: "0", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
                React.createElement("g", null,
                    React.createElement("path", { d: "M15.692 10.686c2.066.042 3.107-2.057 3.184-3.836h-2.119c-.135 1.342-.41 2.62-1.065 3.836zM5.112 6.837c.133 1.981 1.232 3.91 3.191 3.841-.654-1.207-.925-2.508-1.067-3.84H5.111zM20 5.747v1.071c-.093.45-.17.905-.28 1.351-.479 1.917-1.813 3.744-4.48 3.595-.119-.007-.278.105-.363.208-.481.584-1.026 1.082-1.722 1.401-.081.038-.19.136-.192.208-.015.722-.009 1.443-.009 2.202h2.307v1.43l.737.034V18H8.006v-.756l.759-.034v-1.451h2.282c0-.742.007-1.442-.009-2.142-.002-.084-.107-.202-.194-.242-.683-.316-1.235-.793-1.69-1.383-.138-.179-.277-.233-.5-.246-.516-.03-1.05-.046-1.539-.194-1.428-.433-2.224-1.518-2.677-2.874-.202-.6-.295-1.239-.438-1.86V5.747h3.189V5h9.633v.747H20z" })))));
    };
    return Trophy;
}(React.Component));
export { Trophy };
export default Trophy;
//# sourceMappingURL=Trophy.js.map